export default function DecorativeImage(el: string) {

  const element = document.querySelector(`#${el}`);

  if (!element) {
    return;
  }

  const preSibling = element.closest('.row-parent')?.previousElementSibling as HTMLElement;
  preSibling?.classList.add('decorative-image-pre-row');

}